<template>
  <div>
    <div class="navLogo">
      <h1>
        NOTARIA VILCA
        <svg
          class="bi bi-list"
          width="1em"
          height="1em"
          viewBox="0 0 16 16"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          @click="menuDisplay"
        >
          <path
            fill-rule="evenodd"
            d="M2.5 11.5A.5.5 0 013 11h10a.5.5 0 010 1H3a.5.5 0 01-.5-.5zm0-4A.5.5 0 013 7h10a.5.5 0 010 1H3a.5.5 0 01-.5-.5zm0-4A.5.5 0 013 3h10a.5.5 0 010 1H3a.5.5 0 01-.5-.5z"
            clip-rule="evenodd"
          />
        </svg>
      </h1>
    </div>
    <nav v-if="menu" id="desktopMenu">
      <ul class="nav">
        <!-- <li class="nav-item">
          <router-link to="/" class="nav-link">NOTARIA VILCA</router-link>
        </li>-->
        <li class="nav-item">
          <!-- <a class="nav-link" href="#">Inicio</a> -->
          <router-link to="/" class="nav-link">Inicio</router-link>
        </li>
        <li class="nav-item">
          <!-- <a class="nav-link" href="#">Consulta</a> -->
          <router-link to="/consulta" class="nav-link">Verifico certificaciones</router-link>
        </li>
        <li class="nav-item">
          <!-- <a class="nav-link" href="#">Inicio</a> -->
          <router-link to="/tramites" class="nav-link">Saco mi cita</router-link>
        </li>
        <li v-if="login" class="nav-item">
          <!-- <a class="nav-link" href="#">Consulta</a> -->
          <router-link to="/usuario" class="nav-link">
            <div>Mi cuenta</div>
          </router-link>
        </li>
        <li v-if="!login" class="nav-item">
          <!-- <a class="nav-link" href="#">Consulta</a> -->
          <router-link to="/ingresar" class="nav-link">Mi cuenta</router-link>
        </li>
      </ul>
    </nav>
    <nav v-if="!menu" id="mobMenu">
      <ul class="nav">
        <!-- <li class="nav-item">
          <router-link to="/" class="nav-link">NOTARIA VILCA</router-link>
        </li>-->
        <li class="nav-item">
          <!-- <a class="nav-link" href="#">Inicio</a> -->
          <router-link to="/" class="nav-link">
            <div @click="menuDisplay">Inicio</div>
          </router-link>
        </li>
        <li class="nav-item">
          <!-- <a class="nav-link" href="#">Inicio</a> -->
          <router-link to="/consulta" class="nav-link">
            <div @click="menuDisplay">Verifico certificaciones</div>
          </router-link>
        </li>
        <li class="nav-item">
          <!-- <a class="nav-link" href="#">Consulta</a> -->
          <router-link to="/tramites" class="nav-link">
            <div @click="menuDisplay">Saco mi cita</div>
          </router-link>
        </li>
        <li v-if="login" class="nav-item">
          <!-- <a class="nav-link" href="#">Consulta</a> -->
          <router-link to="/usuario" class="nav-link">
            <div @click="menuDisplay">Mi Cuenta</div>
          </router-link>
        </li>
        <li v-if="!login" class="nav-item">
          <!-- <a class="nav-link" href="#">Consulta</a> -->
          <router-link to="/ingresar" class="nav-link">
            <div @click="menuDisplay">Mi Cuenta</div>
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
export default {
  name: "NavComponent",
  props: ["login"],
  mounted() {
    this.$store.dispatch("loadUser");
    this.salirFlag=this.login
  },
  data: () => {
    return {
      menu: true
    };
  },
  methods: {
    menuDisplay() {
      this.menu = !this.menu;
    }
  }
};
</script>
<style lang="scss">
/* eslint-disable */
body {
  margin: 0px;
}
#mobMenu {
  display: none;
}
#desktopMenu {
  display: block;
}

.mainContainer {
  margin: 30px auto;
  background-color: WHITE;
  width: 900px;
  border-width: 1px 1px 1px 1px;
  border-style: solid;
  overflow: hidden;
  border-color: #556273;
}
@media (min-width: 700px) and (max-width: 1150px) {
  .mainContainer {
    width: 90%;
  }
}
.navLogo {
  svg {
    display: none;
  }

  background-color: $p-color;
  color: $s-color;
  width: 250px;
  height: 250px;
  box-sizing: border-box;
  padding: 70px 35px;
  box-shadow: 3px 0px 3px 0px rgba(0, 0, 0, 0.75);
  position: absolute;
  z-index: 20;
  h1 {
    font-family: "Raleway";
    font-size: 2.6em;
    font-weight: bold;
    margin: 0px;
    line-height: 1.2em;
  }
}
.nav {
  background-color: $body-bg;
  margin-left: 270px;
  float: right;
  .nav-item {
    text-align: center;
    display: inline-block;
    margin: 0px 6px;
    a {
      padding: 10px 10px;
      text-decoration: none;
      display: block;
    }
  }
  .nav-link {
    color: #556273;
    font-style: italic;
    border-bottom: 2px #556273 solid;
  }
  .nav-item .active {
    padding: 10px 30px;
    border-bottom-color: #0e263f;
    color: #0e263f;
  }
  .nav-link:hover {
    color: #0e263f;
    font-style: italic;
    border-bottom: 2px #0e263f solid;
  }
}

@media (max-width: 700px) {
  .mainContainer {
    border-width: 0px;
  }
  #mobMenu {
    display: inline;
  }
  #desktopMenu {
    display: none;
  }

  .mainContainer {
    width: 100%;
    margin: 0px;
  }
  .navLogo {
    text-align: center;
    display: block;
    width: 100%;
    height: initial;
    padding: 0px;
    svg {
      display: inline-block;
    }
    h1 {
      margin: 0px;
      padding: 5px 0px;
      width: 100%;
      font-size: 2em;
      font-weight: bold;
      font-family: "Raleway";
      padding-left: 35px;
      box-sizing: border-box;
    }
    svg {
      font-size: 36px;
      padding: 1px 0px 5px 0px;
      float: right;
    }
  }
  .nav {
    background-color: $p-color;
    width: 100%;
    display: block;
    margin-top: 50px;
    text-align: left;
    position: absolute;
    z-index: 30;
    margin-left: 0px;
    .nav-link {
      color: $s-color;
    }
    .nav-item {
      display: block;
      width: 100%;
      padding: 9px 0px;
      .nav-link {
        text-align: center;
      }
    }
  }
  .nav .mob {
    display: none;
  }
}
</style>
